// bodyFormat.mjs — 第八十八批：ticket / 工作项正文是 markdown 还是纯文本。
//
// ── 病灶 ────────────────────────────────────────────────────────────────────
// 系统里很多 ticket 与工作项的正文本来就是用 md 语法写的（`--body-file` 收的就是
// 一份 .md），而展示侧一路是 `whiteSpace: 'pre-wrap'` 的纯文本——于是读者看到的是
// `**粗体**`、`| 表头 |` 这些**原始标记**。写的人以为写的是格式，读的人看到的是噪音。
//
// ── 需求方裁（2026-08-06）─────────────────────────────────────────────────────
// 「一律按 markdown 渲染（含存量），另给撰写者一个纯文本开关作为出口」。
// 于是这里只有两种取值，且**未知一律当 markdown**：
//   · 存量行的 body_format 是 NULL，按裁决它们要被渲染 ⇒ 缺省必须是 markdown；
//   · 将来若多出第三种取值而前端还没跟上，退化成 markdown 也比退化成一堆原始标记好。
export const BODY_FORMATS = ['markdown', 'text'];

// 只有**逐字** 'text' 才算纯文本。这条刻意写得严：一个拼错的值（'plain'、'txt'）
// 退化成 markdown，而不是退化成"谁也说不清是什么"。
export function normalizeBodyFormat(v) {
  return v === 'text' ? 'text' : 'markdown';
}

// 这一段正文此刻该不该走渲染器。`showSource` 是**读者侧**的临时开关：
// 存量 ticket 没有任何写路径（网关里根本没有 ticket 的 PATCH/PUT），所以一条被
// 渲染坏了的老正文，作者是改不了它的 body_format 的——读者这一侧必须有个出口，
// 否则"给出口"这条裁决对它要保护的那批人恰好不成立。
export function shouldRenderMarkdown(format, showSource) {
  return normalizeBodyFormat(format) === 'markdown' && !showSource;
}

// 提交面用：把表单上的布尔翻成要发给后端的值。
// 发 'markdown' 而不是省略字段——省略与"我选了 markdown"在请求里长得一样，
// 而后端将来若改默认值，省略的那些会跟着变，显式的不会。
export function bodyFormatFromToggle(plainText) {
  return plainText ? 'text' : 'markdown';
}
